import { render, staticRenderFns } from "./tcDivideExpense.vue?vue&type=template&id=56ac2f06&scoped=true&"
import script from "./tcDivideExpense.vue?vue&type=script&lang=js&"
export * from "./tcDivideExpense.vue?vue&type=script&lang=js&"
import style0 from "./tcDivideExpense.vue?vue&type=style&index=0&id=56ac2f06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac2f06",
  null
  
)

export default component.exports